// extracted by mini-css-extract-plugin
export var imageCenter = "index-module--imageCenter--64bb9";
export var imageLeft = "index-module--imageLeft--ac354";
export var imageRight = "index-module--imageRight--6c441";
export var images = "index-module--images--19e53";
export var links = "index-module--links--52f9f";
export var mainHeading = "index-module--mainHeading--81b96";
export var reverseColumns = "index-module--reverseColumns--42bc1";
export var textAndSplitImages = "index-module--textAndSplitImages--539d4";